__turbopack_context__.v({
  "button": "TeaserClusterFooter-module-scss-module__FiVB-a__button",
  "footerContainer": "TeaserClusterFooter-module-scss-module__FiVB-a__footerContainer",
  "native": "TeaserClusterFooter-module-scss-module__FiVB-a__native",
  "nativeLink": "TeaserClusterFooter-module-scss-module__FiVB-a__nativeLink",
  "noBorder": "TeaserClusterFooter-module-scss-module__FiVB-a__noBorder",
  "premium": "TeaserClusterFooter-module-scss-module__FiVB-a__premium",
});
